import { TabPanel } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledTabPanel = styled(TabPanel)`
  padding: 0px 20px;
  margin-bottom: 12px;

  ${TabPanel.Styled.Tablist} {
    justify-content: flex-start;
    gap: 4px;
  }

  ${TabPanel.Styled.TabPanel} {
    height: auto;
    min-height: unset;
  }

  ${TabPanel.Styled.Tab} {
    padding: 6px 16px;
  }

  ${TabPanel.Styled.Tab}[aria-selected='true'] {
    border-width: 1px 1px 0px 1px;
    border-style: solid;
    border-color: var(--border-soft);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

export const Placeholder = styled.div`
  padding: 8px 0;
  color: var(--text-secondary);
`;

export const TabsContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 20px;
  width: 100%;
  flex: 1 1 0px;
  min-height: 0;
`;
